export default __webpack_public_path__ + "static/media/Albanian.407d9f61.mp3";